import { skipToken, useSuspenseQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useMemo } from "react";

const GENERATOR_STATUS_SUMMARY = gql(`
  query GeneratorStatusSummary($facilityId: ID!, $startDate: Date, $endDate: Date) {
    generatorStatusSummary(facilityId: $facilityId, startDate: $startDate, endDate: $endDate) {
          currentlyReportedStatus{
            fedWasteGenerator{
              status
              createdDate
            }
            stateWasteGenerator{
              status
              createdDate
            }
          }
          statusChanges {
            changes {
              month
              reportedFederalGeneratorStatus
              reportedStateGeneratorStatus
            }
            changeCount
          }
          exceedances {
            month
            reportedFederalGeneratorStatus
            calculatedFederalGeneratorStatus
          }
          belowThreshold {
            month
            reportedFederalGeneratorStatus
            calculatedFederalGeneratorStatus
          }
        }
  }
`);

export const useGeneratorStatusSummary = (
  facilityId: string | undefined,
  startDate: Date | null,
  endDate: Date | null
) => {
  const options = useMemo(() => {
    if (!facilityId || !startDate || !endDate) {
      return skipToken;
    }
    return { variables: { facilityId: facilityId ?? "", startDate, endDate } };
  }, [facilityId, startDate, endDate]);
  return useSuspenseQuery(GENERATOR_STATUS_SUMMARY, options);
};
